import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { SharedModule as CwKSharedModule } from '@cwkhome/shared/shared.module';

import { ActionButtonComponent } from './components/action-button/action-button.component';
import { CountdownTimerComponent } from './components/countdown-timer/countdown-timer.component';
import { CountryFlagComponent } from '@shared/components/country-flag/country-flag.component';
//import { NewlinePipe } from '@shared/pipes/newline.pipe';
import { StudentFormComponent } from '@shared/components/student-form/student-form.component';
import { StudentLoginFormComponent } from '@shared/components/student-login-form/student-login-form.component';

@NgModule({
  declarations: [
    ActionButtonComponent,
    CountdownTimerComponent,
    CountryFlagComponent,
    //NewlinePipe,
    StudentFormComponent,
    StudentLoginFormComponent
  ],
  exports: [
    ActionButtonComponent,
    CountdownTimerComponent,
    CountryFlagComponent,
    CwKSharedModule,
    //NewlinePipe,
    StudentFormComponent,
    StudentLoginFormComponent
  ],
  imports: [
    CommonModule,
    CwKSharedModule,
    FontAwesomeModule,
    FormsModule,
    RouterModule,
    NgbModule
  ],
  providers: [
    CurrencyPipe
  ]
})
export class SharedModule { }
